import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7.8967" cy="6.6977" r="1.91645" fill={color} stroke={color} strokeWidth="1.125"/>
        <rect x="1.0625" y="1.0625" width="13.875" height="13.875" rx="4.71375" stroke={color} strokeWidth="1.125" fill="none" />
        <path d="M3.25737 13.7422C4.00156 11.8507 5.84459 10.5118 8.00031 10.5118C10.156 10.5118 11.9991 11.8507 12.7433 13.7422" stroke={color} strokeWidth="1.125"/>
        <path d="M4.96773 11.9504L3.54688 13.9766L4.56999 14.4791C4.7758 14.5802 5.00204 14.6328 5.23134 14.6328H8.53906H10.3315C10.4795 14.6328 10.6266 14.6109 10.7682 14.5678L12.7109 13.9766L11.913 12.8187C11.8514 12.7294 11.7803 12.647 11.7009 12.5729L11.0603 11.9755C10.9581 11.8802 10.8431 11.7996 10.7185 11.7361L9.86439 11.3007C9.73158 11.2329 9.58942 11.1854 9.4426 11.1596L8.12876 10.9289C8.04308 10.9138 7.95626 10.9062 7.86927 10.9062H7.01491C6.78412 10.9062 6.55646 10.9595 6.34961 11.0619L5.53057 11.4672C5.30546 11.5786 5.11193 11.7447 4.96773 11.9504Z" fill={color}/>
    </svg>
)

export default class IconProfileSquare extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
